import React from 'react';
import { locales } from '../translations/locales';

const Footer = (props) => {
    const { locale, theme } = props;
    return (
        <div className={`footer has-text-centered is-flex center h-${theme === 'DARK' ? 'dark' : 'light'}`}>
            <div className="container has-padding">
                <div className='row text-center'>
                    <div className='col m-2'>
                        Copyright © {locales[locale].title} {new Date().getFullYear()} {locales[locale].allRights}.
                    </div>
                </div>
                <div className='row m-1'>
                    <div className='col m-1'>
                        <a href="https://alertes-speciales.fr/documents/mentions-legales/" className="m-2">
                            {locales[locale].footer.legalNotice}
                        </a>
                    </div>
                    <div className='col m-1'>
                        <a href="https://alertes-speciales.fr/documents/conditions-utilisation/" className="m-2">
                            {locales[locale].footer.termsOfService}
                        </a>
                    </div>
                    <div className='col m-1'>
                        <a href="https://alertes-speciales.fr/documents/politique-confidentialite/" className="m-2">
                            {locales[locale].footer.privacyPolicy}
                        </a>
                    </div>
                    <div className='col m-1'>
                        <a href="https://alertes-speciales.fr/documents/conditions-generales-vente/" className="m-2">
                            {locales[locale].footer.termsOfSales}
                        </a>
                    </div>
                    <div className='col m-1'>
                        <a href="https://alertes-speciales.fr/documents/credits/" className="m-2">
                            {locales[locale].footer.credits}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;
